import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiButtonModule} from "@snelstart/ui-button";

@Component({
    selector: 'snelstart-venture-fiscaal-feature-tekst-wuo-vragenVooraf',
    standalone: true,
    imports: [CommonModule, SharedUiButtonModule],
    templateUrl: './tekst-wuo-vragenVooraf.component.html',
    styleUrl: './tekst-wuo-vragenVooraf.component.scss',
})
export class TekstOndernemingVragenVoorafComponent implements OnInit {

    @Input() public id!: string;
    public ibAangifte = {} as Aangifte;
    public focusedElementId: string | null = null;
    public year = 2024;
    public actualYear: number = new Date().getFullYear();
    public stakingsaftrek = 0;

    constructor(
        public dataService: BokkzIbDataService) {
    }

    ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((value) => {
            if (value.year !== undefined) {
                this.year = value.year;
            }
            if (this.year === 2023) {
                this.stakingsaftrek = 3630;
            }
            if (this.year === 2024) {
                this.stakingsaftrek = 3630;
            }
            if (this.year === 2025) {
                this.stakingsaftrek = 3630;
            }
        })
    }

}
